import { useEffect, useState } from 'react'

import BasicTable from 'Components/UI/Atoms/BasicTable'
//import { EditContext } from "Components/Hooks/ContextEdit"
//import useCustomSnackbar from "Components/UI/Atoms/SnackBar"

const Comprobantes = ({ data, dataBefore }) => {
  //const [edit] = useContext(EditContext)
  //const [isLoading, setIsLoading] = useState(false)
  const [formEdit, setFormEdit] = useState(data.comprobantes)

  //const createDismissableSnackbar = useCustomSnackbar()

  useEffect(() => {
    setFormEdit(data.comprobantes)
  }, [data.comprobantes])

  //   async function apiCall(id) {
  //       await interfaces.salesSuppliers
  //       .infoOneSupplier(id)
  //       .then((res) => {
  //         setFormEdit({
  //           data: res.data.details
  //         })
  //       })
  //     }
  //     !formEdit && apiCall()

  return (
    <>
      <div>
        <BasicTable
          col={[
            { title: 'Tipo', style: { width: '60px' } },
            { title: 'Comprobante', style: { width: '80px' } },
            { title: 'Debe', style: { width: '90px' } },
            { title: 'Haber', style: { width: '90px' } },
            { title: 'Saldo', style: { width: '90px' } },
            { title: 'Fecha', style: { width: '80px' } },
            { title: 'Usuario', style: { width: '60px' } },
            { title: 'Estado', style: { width: '100px' } },
          ]}
          size="small"
          rows={formEdit.map((row) => {
            return {
              tipo: row.tipo,
              comprobante: row.comprobante,
              debe: `$${Number(row.debe).toLocaleString('es-AR', { minimumFractionDigits: 2 })}`,
              haber: `$${Number(row.haber).toLocaleString('es-AR', { minimumFractionDigits: 2 })}`,
              saldo: `$${Number(row.saldo).toLocaleString('es-AR', { minimumFractionDigits: 2 })}`,
              fecha: row.fecha,
              usuario: dataBefore?.data?.usuarios.find((u) => u.id === row.usuario)?.fullName,
              estado: row.estado,
            }
          })}
        />
      </div>
      {/* <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              margin: "10px 40px 10px 10px",
            }}>
              <Table 
                formEdit={formEdit} 
                isLoading={isLoading}
                edit={edit}
                setFormEdit={setFormEdit}
                data={data}
                onDataChange={onDataChange}
                setIsLoading={setIsLoading}
                setRender={setRender}
                render={render}
              />
          </div> */}
    </>
  )
}

export default Comprobantes
